import React, { useEffect, useState } from "react";
import ApiClient from "ApiClient";
import axios from "axios";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import "./Home.css";
import Routes from "Components/Routes";
import DnsServers from "Components/DnsServers/DnsServers";
import WithLoading from "Components/WithLoading";

function Home() {
  const [dnsServers, setDnsServers] = useState([]);
  const [dnsServerResults, setDnsServerResults] = useState([]);
  const [inputQuery, setInputQuery] = useState("");
  const [queryType, setQueryType] = useState("A");
  const [resultRequestCancellationToken, setResultRequestCancellationToken] = useState(null);
  const DnsServersWithLoading = WithLoading(DnsServers);

  useEffect(() => {
    ApiClient.get("GetDnsServers")
      .then((res) => {
        setDnsServers(res.data.dnsServers);
      })
      .catch((error) => {
        toast.error(
          <div>
            <p>We could not communicate with the API right now. Please try again in a few seconds</p>
            <p>If the issue persists please contact the website Administrator</p>
          </div>
        );
      });
  }, []);

  function fetchDnsResults() {
    let trimmedQuery = inputQuery.trim();

    if (trimmedQuery.length === 0) {
      return;
    }

    if (resultRequestCancellationToken != null) {
      resultRequestCancellationToken.cancel();
    }
    setDnsServerResults([]);

    let source = axios.CancelToken.source();
    setResultRequestCancellationToken(source);

    dnsServers.forEach((item, i) => {
      setDnsServerResults((dnsServerResults) => ({
        ...dnsServerResults,
        [item.id]: {
          fetching: true,
        },
      }));

      ApiClient.post(
        "Resolve",
        {
          serverId: item.id,
          query: trimmedQuery,
          queryType: queryType,
        },
        {
          cancelToken: source.token,
        }
      )
        .then((res) => {
          setDnsServerResults((dnsServerResults) => ({
            ...dnsServerResults,
            [res.data.serverId]: { fetching: false, success: true, data: res.data.data },
          }));
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            return;
          }

          if (error.response != null) {
            let serverId = JSON.parse(error.config.data).serverId;

            if (serverId === null) {
              return;
            }

            let errors = [];
            for (let a in error.response.data.errors) {
              error.response.data.errors[a].forEach((item, i) => {
                errors.push(item);
              });
            }

            setDnsServerResults((dnsServerResults) => ({
              ...dnsServerResults,
              [serverId]: { fetching: false, errors: errors, success: false },
            }));
          } else {
            toast.error(
              <div>
                <p>We could not communicate with the API right now. Please try again in a few seconds</p>
                <p>If the issue persists please contact the website Administrator</p>
              </div>,
              {
                toastId: "request-failed",
              }
            );
          }
        });
    });
  }

  function handleFormSubmit(e) {
    e.preventDefault();
  }

  return (
    <>
      <div className="row mt-4">
        <div className="col-md-6">
          <div className="row">
            <form className="form-inline col-12 mb-4" onSubmit={handleFormSubmit}>
              <input required placeholder="example.com" className="form-control shadow-sm flex-grow-1 mb-2 mb-sm-0" type="text" onChange={(e) => setInputQuery(e.target.value)}></input>
              <select onChange={(e) => setQueryType(e.target.value)} className="custom-select mb-2 mb-sm-0">
                <option value="A">A</option>
                <option value="MX">MX</option>
                <option value="NS">NS</option>
                <option value="TXT">TXT</option>
                <option value="AAAA">AAAA</option>
                <option value="CNAME">CNAME</option>
                <option value="SOA">SOA</option>
                <option value="PTR">PTR</option>
                <option value="SRV">SRV</option>
              </select>
              <button className="btn btn-primary pl-4 pr-4 shadow-sm" type="submit" onClick={fetchDnsResults}>
                Start
              </button>
            </form>
          </div>

          <DnsServersWithLoading isLoading={dnsServers.length === 0} dnsServers={dnsServers} dnsServerResults={dnsServerResults}></DnsServersWithLoading>
        </div>

        <div className="col-md-6 mt-4 mt-md-0">
          <div className="col-12 text-justify">
            <h1 className="h3 roboto-condenced text-uppercase">DNS Propagation Checker</h1>
            <p>
              <strong className="font-weight-bold">dnschecker.totalbits.com</strong> is the perfect tool when troubleshooting various connectivity problems, such as, website, hosting and email configuration.
            </p>
            <p>
              Have you ever moved to a new hosting provider or had to change the IP address of your server? Did you ever wonder if the rest of the world could see the changes you have made to the DNS records? Then you are in the right place! We have over <b className="font-weight-bold">20+ DNS servers</b> ready to answer that question.
            </p>
            <p>
              For any feedback or inquiries please{" "}
              <NavLink className="hyperlink" activeClassName="hyperlink-active" exact to={Routes.contact}>
                contact us
              </NavLink>
              . We would love to hear from you.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
